import {FabricObject} from 'fabric';

/*
 * Fabric v7 changed the default originX/originY from 'left'/'top' to 'center'.
 * All boards saved under Fabric 5 and all of the positioning math in this
 * engine assume top-left origins, so restore the old defaults globally.
 * Import this module (for side effects) before creating any fabric objects.
 */
FabricObject.ownDefaults.originX = 'left';
FabricObject.ownDefaults.originY = 'top';
